import { Box } from '@mui/material';
import { common } from '@mui/material/colors';
import {
    BaseMultiCheckbox,
    BaseMultiCheckboxWithImage,
} from 'common/components/base-checkbox-group';
import { colors } from 'common/constants';
import React from 'react';
interface Props {
    name: string;
    options: { label: string; value: string; image: string }[];
}
const QuestionCheckbox: React.FC<Props> = ({ name, options }) => {
    // console.log(options.some((option) => option.image));
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: ['center', 'flex-start'],
                alignItems: 'center',
            }}
        >
            {options.some((option) => option.image) ? (
                <BaseMultiCheckboxWithImage
                    name={name}
                    options={options}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        '& .MuiFormControlLabel-label': {
                            color: [common.white, common.black],
                            fontWeight: '500',
                            fontSize: [
                                '0.7rem',
                                '1rem',
                                '1rem',
                                '1.6rem',
                                '1.8rem',
                            ],
                        },
                    }}
                    sxCheckbox={{
                        '& .MuiSvgIcon-root': { fontSize: [24, 32] },
                        '& .MuiFormControlLabel-label': {
                            fontWeight: '500',
                        },
                        '&.Mui-checked + .MuiFormControlLabel-label': {
                            color: colors.main,
                            fontWeight: '500',
                        },
                    }}
                />
            ) : (
                <BaseMultiCheckbox
                    name={name}
                    options={options}
                    sx={{
                        '& .MuiFormControlLabel-root': {
                            marginLeft: [0, '-11px'],
                            marginRight: [0, '16px'],
                            marginBottom: ['16px', 'unset'],
                            width: ['100%', 'unset'],
                        },
                        '& .MuiFormControlLabel-label': {
                            color: common.black,
                            fontWeight: '500',
                            fontSize: [
                                '0.9rem',
                                '1rem',
                                '1rem',
                                '1.6rem',
                                '1.8rem',
                            ],
                        },
                    }}
                    sxCheckbox={{
                        '& .MuiButtonBase-root': {
                            display: ['none', 'inline-flex'],
                        },
                        '& .MuiSvgIcon-root': {
                            fontSize: [24, 24, 24, 24, 32, 34],
                        },
                        '& .MuiFormControlLabel-label': {
                            color: common.black,
                            fontWeight: '500',
                            cursor: 'pointer',
                            backgroundColor: ['#fff', 'unset'],
                            width: '100%',
                            padding: ['1rem', 0],
                            borderRadius: '50px',
                        },
                        '&.Mui-checked ~ .MuiFormControlLabel-label': {
                            color: ['#fff', colors.main],
                            backgroundColor: [colors.main, 'unset'],
                            fontWeight: '500',
                        },
                    }}
                />
            )}
        </Box>
    );
};

export default QuestionCheckbox;
